export default __webpack_public_path__ + "static/media/Arrowdown.b0f47bbd.svg";